module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {}, [_c('div', {}, [_c('div', {}, [_c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }), _vm._v(" "), _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "75vh"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 18,
      "map-type-id": "terrain"
    }
  }, _vm._l((_vm.locations), function(gmp, index) {
    return _c('gmap-marker', {
      key: 'A' + index,
      attrs: {
        "position": gmp,
        "icon": _vm.getMarkerIcon(gmp)
      },
      on: {
        "click": function($event) {
          _vm.showLocByIndex(index)
        },
        "closeclick": function($event) {
          _vm.showLocByIndex(null)
        }
      }
    }, [_c('gmap-info-window', {
      attrs: {
        "closeclick": true,
        "opened": _vm.showByIndex === index
      },
      on: {
        "closeclick": function($event) {
          _vm.showLocByIndex(null)
        }
      }
    }, [_c('div', {
      staticClass: "houseInfo"
    }, [(gmp.hasOwnProperty('surveyorDetails')) ? _c('div', [_c('div', [_c('span', {
      staticStyle: {
        "font-size": "12px",
        "font-weight": "550"
      }
    }, [_vm._v(_vm._s(gmp.surveyorDetails.firstName + ' ' + gmp.surveyorDetails.lastName) + " ")])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(gmp.surveyorDetails.mobile))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(gmp.details.updatedAt ? _vm.updatedTime(gmp.details.updatedAt) : '--'))])])]) : _vm._e()])])], 1)
  }))], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-14d1fded", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14d1fded"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/gmapLocation/tracking.vue
// module id = 2261
// module chunks = 0